import {
  Button,
  Spacer,
  SvgPlayCircle,
  SvgVideoCam,
  Text,
  TextButton,
  Tooltip,
} from '@loomhq/lens';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { showErrorBar } from 'actions/errorBar';
import { openModal } from 'actions/modals';
import { DOWNLOAD_RECORDER } from 'constants/checklist';
import { ERROR } from 'constants/error-severities';
import { GET_STARTED_CHECKLIST_START_RECORDING_CLICKED } from 'constants/events';
import { CHECKLIST_RECORD_BUTTON_MODAL } from 'constants/modalTypes';
import * as analytics from 'utilities/analytics';
import {
  isInstalled,
  requestExtensionOpenIfInstalled,
} from 'utilities/extension';
import * as logger from 'utilities/loggerx';

import { useGetCheckListStatus } from 'hooks/getStartedChecklist';
import {
  selectUserHasUsedDesktop,
  selectUserHasUsedExtension,
} from 'selectors/user';

const RecordCTA = () => {
  const dispatch = useDispatch();
  const [extensionIsInstalled, setExtensionIsInstalled] = useState(false);
  const hasUsedExtension = useSelector(selectUserHasUsedExtension);
  const hasUsedDesktop = useSelector(selectUserHasUsedDesktop);
  const checklistStatus = useGetCheckListStatus();

  const hasRecorder =
    hasUsedDesktop || (hasUsedExtension && extensionIsInstalled);
  const isDisabled = !hasRecorder && !checklistStatus[DOWNLOAD_RECORDER];

  useEffect(() => {
    isInstalled(installed => {
      setExtensionIsInstalled(installed);
    });
  }, []);

  const startRecording = () => {
    if (hasUsedExtension && extensionIsInstalled) {
      requestExtensionOpenIfInstalled('first-video-share-modal', success => {
        if (!success) {
          logger.error(
            'Unable to re-record with the browser extension from the get started checklist'
          );

          dispatch(
            showErrorBar(
              ERROR,
              'An error occurred attempting to start a recording'
            )
          );
        }
      });

      return;
    }

    if (hasUsedDesktop) {
      document.location.href = 'loomdesktop://';

      return;
    }

    dispatch(openModal(CHECKLIST_RECORD_BUTTON_MODAL));
  };

  const tooltipText = !hasRecorder
    ? 'Download Loom, then start recording!'
    : null;

  return (
    <div>
      <Text>
        Record a short video to share with your teammates. Try introducing
        yourself or replacing a meeting.
      </Text>
      <Spacer top="large" bottom="medium">
        <Tooltip content={tooltipText} placement="bottomCenter" maxWidth={32}>
          <Button
            icon={<SvgVideoCam />}
            variant="record"
            disabled={isDisabled}
            onClick={() => {
              analytics.track(GET_STARTED_CHECKLIST_START_RECORDING_CLICKED);
              startRecording();
            }}
          >
            Start Recording
          </Button>
        </Tooltip>
      </Spacer>
      <TextButton
        icon={<SvgPlayCircle />}
        size="small"
        onClick={() => {
          document.location =
            'https://www.loom.com/share/6670e3eba3c84dc09ada8306c7138075?t=0';
        }}
      >
        Learn how to record
      </TextButton>
    </div>
  );
};

export default RecordCTA;
